class Notify {
    constructor() {
        this.TIMEOUT_DELAY = 5000;
        this.timerId = [];
        this.messageContainer = $('#error-container');
    }

    onSuccess(message, time) {
        message = message || 'Данные сохранены';
        time = time || this.TIMEOUT_DELAY;
        const messageObj = this.getMessageForm('onSuccess', message);
        this.messageContainer.append(messageObj);
        this.showInShortTime(messageObj, time);
    }

    onError(message, time) {
        message = message || 'Произошла ошибка, пожалуйста, обратитесь к администратору';
        time = time || this.TIMEOUT_DELAY;
        const messageObj = this.getMessageForm('error', message);
        this.messageContainer.append(messageObj);
        this.showInShortTime(messageObj, time);
    }

    showInShortTime(self, time) {
        this.timerId[this.timerId.length] = setTimeout(() => {
            $(self).fadeOut(500, function () {
                $(this).remove();
            });
        }, time);
    }

    getMessageForm(method, message) {
        const formStr = `${''
            + '<div class="error-block '}${method === 'onSuccess' ? 'success' : 'fail'}">`
            + '   <div class="error-icon">'
            + `       <span class="glyphicon ${method === 'onSuccess' ? 'glyphicon-ok' : 'glyphicon-remove'}">`
            + '       </span>'
            + '   </div>'
            + '   <div class="error-msg-close">'
            + '       <button type="button" class="close">×</button>'
            + `       <div class="message-container">${message}</div>`
            + '   </div>'
            + '</div>';
        const formObj = $.parseHTML(formStr);
        $(formObj).find('.close').on('click', function () {
            $(this).parent().parent().hide();
        });
        return formObj;
    }

    showMessage(method, message, time) {
        if ($(this.messageContainer).length === 0) {
            this.messageContainer = $('#error-container');
        }
        switch (method) {
            case 'onSuccess':
                this.onSuccess(message, time);
                break;
            case 'onError':
                this.onError(message, time);
                break;
        }
    }
}
export default Notify;
